import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-anesthesiologist',
  templateUrl: './anesthesiologist.component.html',
  styleUrls: ['./anesthesiologist.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AnesthesiologistComponent implements OnInit {

  columnsToDisplay = ['Name', 'Description', 'IsActive'];
  headercolumnsToDisplay = ['Anesthesiologist', 'Description', 'Is Active'];

  public show: boolean = false;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  anesthesiologistform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.anesthesiologistform = this.formBuilder.group({

      name: ['',],
      description: ['',],
      isactive: ['',],
      namee: ['',],
      descriptionn: ['',],
      isactivee: ['',]


    });
  }

  get f() { return this.anesthesiologistform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.anesthesiologistform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.anesthesiologistform.value))
  }
}
